












































import { User } from 'frontend/types';
import { trackClickWithElementId } from 'frontend/utils/nux';
import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

@Component({
  computed: {
    ...mapGetters('dailyChallenges', ['user']),
    ...mapGetters('dailyChallenges', ['featuredCourse']),
  },
})
export default class DcSidebarFeaturedCourse extends Vue {
  private featuredCourse!: object;
  private user!: User;

  private get isCourse() {
    return this.featuredCourse && Object.keys(this.featuredCourse).length;
  }
  private get queryParams() {
    return new URLSearchParams(location.search);
  }

  private get isFromSignup(): boolean {
    if (process.env.VUE_ENV !== 'server') {
      return this.queryParams.get('signedup') === 'true';
    }
    return false;
  }

  private trackClick(axId: string): void {
    if (!this.isFromSignup) {
      trackClickWithElementId(axId);
    }
  }
}
